import { render, staticRenderFns } from "./category-item-content.vue?vue&type=template&id=2d6059a5&"
import script from "./category-item-content.vue?vue&type=script&lang=js&"
export * from "./category-item-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports